import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public readonly MENU_ITEMS = {
    professions: [
      { link: '/berufe/', iconUrl: "/assets/img/teaser/Berufe-erforschen.svg", title: "MENU.PROFESSIONS.DISCOVER_TITLE", abstract: "MENU.PROFESSIONS.DISCOVER_ABSTRACT", target: "" },
      { link: '/berufe/interessensfelder', iconUrl: "/assets/img/teaser/Berufe-erforschen-Interessensfelder.svg", title: "MENU.PROFESSIONS.FEELS_INTEREST_TITLE", abstract: "MENU.PROFESSIONS.FEELS_INTEREST_ABSTRACT", target: "" },
      { link: '/berufe/anforderungen/', iconUrl: "/assets/img/teaser/Berufe-erforschen-Staerken.svg", title: "MENU.PROFESSIONS.STRENGTHS_INTEREST_TITLE", abstract: "MENU.PROFESSIONS.STRENGTHS_INTEREST_ABSTRACT", target: "" }
    ],
    infos: [
      { link: '/infos-angebote/angebote-lehrpersonen', iconUrl: "/assets/img/teaser/Angebote-Lehrpersonen.svg", title: "MENU.INFO_OFFERS.OFFERS_TEACHER_TITLE", abstract: "MENU.INFO_OFFERS.OFFERS_TEACHER_ABSTRACT", target: "" },
      { link: 'https://blog.berufsreise.at', iconUrl: "/assets/img/teaser/Blog.svg", title: "MENU.INFO_OFFERS.BLOG_STUDENTS_TITLE", abstract: "MENU.INFO_OFFERS.BLOG_STUDENTS_ABSTRACT", target: "_blank" },
      { link: '/infos-angebote/infos-lehrpersonen', iconUrl: "/assets/img/teaser/Ideen-Lehrpersonen.svg", title: "MENU.INFO_OFFERS.IDEAS_TEACHER_TITLE", abstract: "MENU.INFO_OFFERS.IDEAS_TEACHER_ABSTRACT", target: "" },
      { link: '/gewinnspiel', iconUrl: "/assets/img/teaser/gewinnspiel.svg", title: "MENU.INFO_OFFERS.LOTTERY_TITLE", abstract: "MENU.INFO_OFFERS.LOTTERY_ABSTRACT", target: "" },
      { link: '/infos-angebote/unternehmen', iconUrl: "/assets/img/teaser/Ideen-Unternehmen.svg", title: "MENU.INFO_OFFERS.IDEAS_COMPANY_TITLE", abstract: "MENU.INFO_OFFERS.IDEAS_COMPANY_ABSTRACT", target: "" },
      { link: '/infos-angebote/faq', iconUrl: "/assets/img/teaser/FAQ.svg", title: "MENU.INFO_OFFERS.FAQ_TITLE", abstract: "MENU.INFO_OFFERS.FAQ_ABSTRACT", target: "" },
    ]
  }

  private _mobileMenuState = new Subject<boolean>();
  private _mobileGameMenuState = new Subject<boolean>();
  constructor() { }


  public onMobileMenuStateChanged(): Observable<boolean> {
    return this._mobileMenuState;
  }

  public setMobileMenuState(val: boolean): void {
    this._mobileMenuState.next(val);
  }

  public onMobileGameMenuStateChanged(): Observable<boolean> {
    return this._mobileGameMenuState;
  }

  public setMobileGameMenuState(val: boolean): void {
    this._mobileGameMenuState.next(val);
  }
}
